export const leaderboard = {
  title: 'Leaderboard',
  back: 'Back',
  filters: {
    level: 'Skill Level',
    country: 'Country',
    city: 'City',
    category: 'Category',
    all: 'All',
  },
  categories: {
    mens_singles: "Men's Singles",
    womens_singles: "Women's Singles",
    mens_doubles: "Men's Doubles",
    womens_doubles: "Women's Doubles",
    mixed_doubles: 'Mixed Doubles',
    all: 'All',
  },
  empty: {
    title: 'No Players Ranked Yet',
    subtitle: 'Be the first to earn points at this level',
  },
  you: 'You',
  points: '{{count}} pts',
  entryPoints: {
    label: 'Beginner Points',
    rule: '+10 points per game won',
    columnHeader: 'Beginner Pts',
  },
  rules: {
    title: 'How Points Work',
    intro: 'ONLY Acework Ranked matches earn points. Both players must confirm + upload court photo to verify.',
    singleMatch: '1v1 Ranked Match Win: +1 pt',
    tournamentRound: 'Tournament Round Win: +10 × multiplier',
    semifinal: 'Semifinal Win (reaching final): +100 × multiplier',
    runnerUp: 'Runner-up: +150 × multiplier',
    champion: 'Champion: +200 × multiplier',
    multiplierTitle: 'Tournament Size Multiplier',
    multiplier4: '4-player: 0.5×',
    multiplier8: '8-player: 1×',
    multiplier16: '16-player: 2×',
    multiplier32: '32-player: 4×',
    cumulative: 'Wins are cumulative. Losses don\'t deduct points.',
    privacyNote: 'Photos auto-delete 2 days after match verifies.',
  },
};
